'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.hmac_sha256 = hmac_sha256;

var _asmcryptoAll = require('asmcrypto.js/asmcrypto.all.js');

var asmcrypto = _interopRequireWildcard(_asmcryptoAll);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function hmac_sha256(key, data) {
	asmcrypto.HMAC_SHA256.BLOCK_SIZE = 64;
	asmcrypto.HMAC_SHA256.HMAC_SIZE = 32;
	return asmcrypto.HMAC_SHA256.bytes(data, key);
}

exports.default = hmac_sha256;